(function () {
    'use strict';

    var imApp = angular.module('imApp');

    imApp.component('ediOrderHeads', {
        templateUrl: 'views/components/views/ediOrderHeads/ediOrderHeads.template.html?v=' + imApp.version,
        controllerAs: 'vm',
        controller: ['ediOrderHeadsService', '$stateParams', '$q', 'utilityService', 'stateService', 'rememberService', 'modalService', function (ediOrderHeadsService, $stateParams, $q, utilityService, stateService, rememberService, modalService) {
            var vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            let variableNames = {
                ordersearch: '',
                status_id: '',
                date_fom: '',
                date_tom: '',
                dateselector_index: ''
            };

            vm.onGridBoxResized = function () {
                vm.gridOrderHead?.gridfunc?.resize();
                vm.gridOrderLine?.gridfunc?.resize();
                vm.gridOrderLineProperty?.gridfunc?.resize();
            }

            vm.model = {
                orderSearchButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('ordersearch') },
                    { id: 'search', icon: 'glyphicon glyphicon-search', color: 'primary', type: 'primary', onClick: () => vm.searchItems() }
                ],
                statusButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('status_id') }
                ],
                ediOrderHeadsViewBoxes: {
                    //height: '25vh',
                    //rememberId: 'ediorderheads.boxes',
                    boxes: [
                        { item_id: uuid(), item_name: 'ediorderhead', type: 'h', size: '33', depth: 0 },
                        { item_id: uuid(), item_name: 'filters', type: 'v', size: '25', depth: 1 },
                        { item_id: uuid(), item_name: 'ediorderheadgrid', type: 'v', size: '75', depth: 1 },
                        { item_id: uuid(), item_name: 'ediorderlines', type: 'h', size: '33', depth: 0 },
                        { item_id: uuid(), item_name: 'ediorderlineproperties', type: 'h', size: '33', depth: 0 }
                    ],
                },
                selectListStatuses: [],
                itemsListOrders: {
                    total: 0,
                    records: []
                },
                buttonStyle: {},
                gridEdiOrderHeadReady: false,
                gridEdiOrderLineReady: false,
                gridEdiOrderLinePropertyReady: false,
                setting: {},
                showFilters: true
            }; 


            vm.gridEdiOrderHead = {
                dataTask: {
                    rememberId: 'w_ediorderheads_ediorderhead_grid',
                    loadSetupId: null,
                    loadData: {},
                    addRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    removeRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    saveData: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    }
                },
                translations: [],
                config: {
                    editColumns: [
                        //{ key: 'test_column' }
                        //'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'
                    ],
                    toolbar: {
                        hidden: false,
                        pdfExport: true,
                        excelExport: true,
                        filter: true,
                        columnVisibility: true,
                        headers: true,
                        edit: false,
                        lock: false,
                        add: false,
                        delete: false,
                        save: false,
                        wrapping: true,
                        layouts: true,
                        buttons: [
                            
                            //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
                            //{ name: 'test', text: '', func: function () { testItems(); } },
                            //{ name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
                            //{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
                            //{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
                            //{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
                        ]
                    },
                    fixedHeader: true,
                    keepSortOnAdd: false,
                    keepSortOnCheckbox: false,
                    keepSortOnIsSelected: false,
                    rowClick: false,
                    //navigation: {
                    //	altNav: true,
                    //	newLine: true
                    //},
                    specialFunc: {
                        newTab: true,
                        buttons: [
                            //{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                        ]
                    },
                    css: {
                        altColor: true,
                        textWrapping: false,
                        height: 'fill'
                    },
                    onDataSourceChanges: function (e) {
                        //setTimeout(() => {
                        //    vm.grid.gridfunc?.getGrid()?.select('tr:eq(0)');
                        //})
                    },
                    onDataChanged: function (changed, e) {
                        //console.log('onDataChanged');
                        //console.dir(e);
                    }
                },
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: {
                        mode: "row",
                        cellAggregates: false,
                        checkboxSelection: false
                    }, //'multiple, row'
                    //persistSelection: false,
                    filterable: false
                },
                onDataBound: () => {
                    setTimeout(() => {
                        try {
                            vm.gridEdiOrderHead.gridfunc.selectRow(0)
                        } catch (error) {

                        }
                    }, 100);
                },

                onDataBinding: () => {
                    vm.gridEdiOrderHead.gridfunc.selectRow(0);
                    vm.model.setting.selected_edi_orderhead_keyno = vm.gridEdiOrderHead.gridfunc.getDataItems()[0]?.edi_orderhead_keyno || '0'
                },

                onSelect: (event) => {
                    if (event.$item) {
                        vm.model.setting.selected_edi_orderhead_keyno = event.$item.edi_orderhead_keyno;

                        loadGridEdiOrderLine();
                        loadGridEdiOrderLineProperty();
                    }
                },
                gridfunc: null
                //optionfunc: function (data) { vm.optionfunc(data.data); },
            };


            vm.gridEdiOrderLine = {
                dataTask: {
                    rememberId: 'w_ediorderheads_ediorderline_grid',
                    loadSetupId: null,
                    loadData: {},
                    addRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    removeRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    saveData: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    }
                },
                translations: [],
                config: {
                    editColumns: [
                        //{ key: 'test_column' }
                        //'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'
                    ],
                    toolbar: {
                        hidden: false,
                        pdfExport: true,
                        excelExport: true,
                        filter: true,
                        columnVisibility: true,
                        headers: true,
                        edit: false,
                        lock: false,
                        add: false,
                        delete: false,
                        save: false,
                        wrapping: true,
                        layouts: true,
                        buttons: [
                            //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
                            //{ name: 'test', text: '', func: function () { testItems(); } },
                            //{ name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
                            //{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
                            //{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
                            //{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
                        ]
                    },
                    fixedHeader: true,
                    keepSortOnAdd: false,
                    keepSortOnCheckbox: false,
                    keepSortOnIsSelected: false,
                    rowClick: false,
                    //navigation: {
                    //	altNav: true,
                    //	newLine: true
                    //},
                    specialFunc: {
                        newTab: true,
                        buttons: [
                            //{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                        ]
                    },
                    css: {
                        altColor: true,
                        textWrapping: false,
                        height: 'fill'
                    },
                    onDataSourceChanges: function (e) {

                    },
                    onDataChanged: function (changed, e) {
                        //console.log('onDataChanged');
                        //console.dir(e);
                    }
                },
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: {
                        mode: "row",
                        cellAggregates: false,
                        checkboxSelection: false
                    }, //'multiple, row'
                    //persistSelection: false,
                    filterable: false
                },
                onDataBound: () => {
                    setTimeout(() => {
                        try {
                            vm.gridEdiOrderLine.gridfunc.selectRow(0)
                            //vm.grid.gridfunc?.getGrid()?.select('tr:eq(0)');
                        } catch (error) {

                        }
                    }, 100);
                },
                //optionfunc: function (data) { vm.optionfunc(data.data); },
                onDataBinding: () => {
                    vm.gridEdiOrderLine.gridfunc.selectRow(0);
                    vm.model.setting.selected_edi_orderline_keyno = vm.gridEdiOrderLine.gridfunc.getDataItems()[0]?.edi_orderline_keyno || '0'
                },

                onSelect: (event) => {
                    if (event.$item) {
                        vm.model.setting.selected_edi_orderline_keyno = event.$item.edi_orderline_keyno;

                        loadGridEdiOrderLineProperty();
                    }
                },
                onReady: () => setTimeout(() => vm.gridEdiOrderLine?.gridfunc?.resize(), 250),
                optionfunc: null,
                gridfunc: null
            };

            vm.gridEdiOrderLineProperty = {
                dataTask: {
                    rememberId: 'w_ediorderheads_ediorderlineproperty_grid',
                    loadSetupId: null,
                    loadData: {},
                    addRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    removeRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    saveData: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    }
                },
                translations: [],
                config: {
                    editColumns: [
                        //{ key: 'test_column' }
                        //'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'
                    ],
                    toolbar: {
                        hidden: false,
                        pdfExport: true,
                        excelExport: true,
                        filter: true,
                        columnVisibility: true,
                        headers: true,
                        edit: false,
                        lock: false,
                        add: false,
                        delete: false,
                        save: false,
                        wrapping: true,
                        layouts: true,
                        buttons: [
                            //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
                            //{ name: 'test', text: '', func: function () { testItems(); } },
                            //{ name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
                            //{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
                            //{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
                            //{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
                        ]
                    },
                    fixedHeader: true,
                    keepSortOnAdd: false,
                    keepSortOnCheckbox: false,
                    keepSortOnIsSelected: false,
                    rowClick: false,
                    //navigation: {
                    //	altNav: true,
                    //	newLine: true
                    //},
                    specialFunc: {
                        newTab: true,
                        buttons: [
                            //{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                        ]
                    },
                    css: {
                        altColor: true,
                        textWrapping: false,
                        height: 'fill'
                    },
                    onDataSourceChanges: function (e) {

                    },
                    onDataChanged: function (changed, e) {
                        //console.log('onDataChanged');
                        //console.dir(e);
                    }
                },
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: {
                        mode: "row",
                        cellAggregates: false,
                        checkboxSelection: false
                    }, //'multiple, row'
                    //persistSelection: false,
                    filterable: false
                },
                onReady: () => setTimeout(() => vm.gridEdiOrderLineProperty?.gridfunc?.resize(), 250),
                optionfunc: null,
                gridfunc: null
            };



            let loadSetting = function () {
                const deferred = $q.defer();

                ediOrderHeadsService.getSetting({
                    argtype: argType,
                    argvalue: argValue
                }).then(function (data) {
                    angular.copy(data[0], vm.model.setting);

                    $q.all().then(() => {
                        loadGridEdiOrderHead();
                        loadGridEdiOrderLine();
                        loadGridEdiOrderLineProperty();

                        deferred.resolve();
                    });
                });

                return deferred.promise;
            };

            let loadStatuses = function () {
                ediOrderHeadsService.getStatusList().then(function (list) {
                    angular.copy(list, vm.model.selectListStatuses);
                });
            };

            var loadGridEdiOrderHead = function () {
                if (argType === 'edi_orderhead_keyno') {
                    vm.model.setting.selected_edi_orderhead_keyno = argValue;
                    vm.model.setting.status_id = '30'; // order created
                }
                else {
                    vm.model.setting.selected_edi_orderhead_keyno = '0';
                };

                var mergeObj = angular.copy(vm.model.setting);

                vm.gridEdiOrderHead.dataTask.loadData = {
                    method: 3667,
                    parameters: mergeObj
                };

                if (vm.gridEdiOrderHead.gridfunc !== null && vm.model.gridEdiOrderHeadReady) vm.gridEdiOrderHead.gridfunc.rebind();

                vm.model.gridEdiOrderHeadReady = true;
            };

            var loadGridEdiOrderLine = function () {
                vm.gridEdiOrderLine.dataTask.loadData = {
                    method: 3671,
                    parameters: vm.model.setting
                };

                if (vm.gridEdiOrderLine.gridfunc !== null && vm.model.gridEdiOrderLineReady) vm.gridEdiOrderLine.gridfunc.read();

                vm.model.gridEdiOrderLineReady = true;
            };

            var loadGridEdiOrderLineProperty = function () {
                vm.gridEdiOrderLineProperty.dataTask.loadData = {
                    method: 3688,
                    parameters: vm.model.setting
                };

                if (vm.gridEdiOrderLineProperty.gridfunc !== null && vm.model.gridEdiOrderLinePropertyReady) vm.gridEdiOrderLineProperty.gridfunc.read();

                vm.model.gridEdiOrderLinePropertyReady = true;
            };

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            let rememberFunc = function (id) {
                angular.forEach(variableNames, function (_, key) {
                    switch (key) {
                        case 'ordersearch':
                        case 'date_fom':
                        case 'date_tom':
                        case 'status_id':
                        case 'dateselector_index':
                            variableNames[key] = stateService.getCurrentName()  + '.' + key;
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;
                let variableValue = null;

                switch (id) {
                    case 'ordersearch':
                        if (utilityService.validateParmsValue(vm.model.setting.ordersearch, true) !== true) return;

                        variableValue = vm.model.setting.ordersearch;
                        break;
                    case 'status_id':
                    case 'date_fom':
                    case 'date_tom':
                    case 'dateselector_index':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }
                return rememberService.remember(variableNames[id], variableValue);
            };

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region RESET BUTTON FUNCTION

            let reset = function (id) {
                switch (id) {
                    case 'ordersearch':
                        vm.model.setting.ordersearch = '';

                        if (vm.model.setting.ordersearch === '') vm.searchItems();
                        break;
                    case 'status_id':
                        vm.model.setting.status_id = '0';

                        if (vm.model.setting.status_id === '0') {
                            //loadOrdersPaged();
                            loadGridEdiOrderHead();
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion RESET BUTTON FUNCTION

            
            vm.searchItems = function () {
                rememberFunc('ordersearch');
                rememberFunc('status_id');
                //loadOrdersPaged();
                loadGridEdiOrderHead();
                loadGridEdiOrderLine();
                loadGridEdiOrderLineProperty();
            };

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                let go = function (parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                };

                switch (state) {
                    /*
                    case 'orderheadcreate':
                        go({
                            argtype: argType,
                            argvalue: argValue,
                            ordertype_id: '0'
                        });
                        break;
                    */
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region FIELD DATE RANGE CHANGE FUNCTION

            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
                vm.model.setting.date_fom = startDate;
                vm.model.setting.date_tom = endDate;
                vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

                if (vm.model.setting.date_fom) rememberFunc('date_fom');
                if (vm.model.setting.date_tom) rememberFunc('date_tom');
                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
                    vm.model.setting.date_fomtom = vm.model.setting.date_fom + vm.model.setting.date_tom;

                    //loadOrdersPaged();
                    loadGridEdiOrderHead();
                }
            };

            // #endregion FIELD DATE RANGE CHANGE FUNCTION

            // #region ON BLUR MULTI FUNCTIONS

            vm.onBlur = function (id) {
                switch (id) {
                    case 'ordersearch':
                        if (utilityService.validateParmsValue(vm.model.setting.ordersearch) !== true) return;

                        if (vm.model.setting.ordersearch > '') vm.searchItems();
                        break;
                    default:
                        break;
                }
            };

            // #endregion ON BLUR MULTI FUNCTIONS


            // #region FIELD CHANGE FUNCTION

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'ordersearch':
                        if (utilityService.validateWatchValue(value, vm.model.setting.ordersearch) !== true) return;

                        vm.model.setting.ordersearch = value;

                        if (utilityService.validateParmsValue(vm.model.setting.ordersearch, true) !== true) return;

                        if (vm.model.setting.ordersearch === '') vm.searchItems();
                        break;
                    case 'status_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting[id]) !== true) return;

                        vm.model.setting[id] = value;

                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        vm.searchItems();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE FUNCTION



            // #region ON INIT FUNCTION

            vm.$onInit = function () {

                if (argType === 'edi_orderhead_keyno') {
                    vm.model.showFilters = false;
                    vm.model.ediOrderHeadsViewBoxes.boxes[1].size = '0';
                    vm.model.ediOrderHeadsViewBoxes.boxes[2].size = '100';

                };

                loadStatuses();
                loadSetting();        
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
